<template src="./menu.html"></template>

<script lang="ts">
export default {
  data() { return { isMenuExpanded: false } },
  props: {
    tiggerAriaLabel: String,
    triggerClass: String,
    triggerType: {
      type: String,
      default: 'icon'
    }
  },
  methods: {
    // this method can be used by the parent to force the menu to close (clicking outside of the
    // menu for example)
    close() {
      this.isMenuExpanded = false
      this.$refs.menuTrigger.$el.focus()
    },
    menuTriggerSelected() {
      this.isMenuExpanded = true
    }
  }
}
</script>

<style lang="scss" src="./menu.scss"></style>
